module.exports = __webpack_public_path__ + "img/pixartprinting-instagram-2.8ac4cea.png";